import { ProductName, LocationType } from '../graphql-client/graphql';

export enum PrintFormType {
  IVF = 'IVF',
  TRF = 'TRF',
  PP = 'PP'
}

export declare interface PdfRequest {
  npi: string;
  physicianTaxID: string;
  speciality: string;
  siteName: string;
  address1: string;
  address2: string;
  city: string;
  state: string;
  zipCode: string;
  phone: string;
  fax: string;
  officeContact: string;
  physicianName: string;
  enumPrintFormType: PrintFormType;
  locationType: LocationType;
  productName: ProductName;
  locationQL: {
    name: string;
    address1: string;
    address2: string;
    city: string;
    state: string;
    zipCode: string;
    phone: string;
    fax: string;
  };
}
